import {createSlice} from "@reduxjs/toolkit";
import {
  ContainerStatusFilterFormValues,
  DataGridPageState,
  DEFAULT_DISPATCH_GO_CONTAINER_STATUS_FILTER
} from "@ots-frontend/ots-ui";
import {
  setContainerStatusPageFilter,
  setContainerStatusPageState,
  setContainerStatusPageStateCell,
  setContainerStatusPageStateSort,
  setContainerStatusPageStateWidths
} from "./actions";

export const CONTAINER_STATUS_PAGE_WIDTHS_KEY = "containerStatusPageWidthsV4";

const savedColWidths = localStorage.getItem(CONTAINER_STATUS_PAGE_WIDTHS_KEY)

type State = {
  filter: ContainerStatusFilterFormValues
  state: DataGridPageState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_DISPATCH_GO_CONTAINER_STATUS_FILTER,
  state: {
    cell: undefined,
    widths: savedColWidths ? JSON.parse(savedColWidths) : [],
  }
};

const containerStatusPageSlice = createSlice({
  name: "ui/container-status-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setContainerStatusPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setContainerStatusPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      setContainerStatusPageStateCell,
      (state, {payload}) => {
        state.state.cell = payload
      }
    );
    builder.addCase(
      setContainerStatusPageStateWidths,
      (state, {payload}) => {
        state.state.widths = payload
      }
    );
    builder.addCase(
      setContainerStatusPageStateSort,
      (state, {payload}) => {
        state.state.sort = payload
      }
    );
  }
});

export const containerStatusPageReducer = containerStatusPageSlice.reducer;
